import { Container } from 'src/components'
import { Section, Wrapper, Divider } from './styles'

// Conteúdo da Política de Privacidade PT
export const Content = () => {
  return (
    <Section>
      <Container>
        <Wrapper>
          <div>
            <p className="h2 title">Política de Privacidade</p>
            <p>Última Modificação: 07.10.25</p>
          </div>
          <Divider className="my-4" />
          <div>
            <p>
              {`A presente Política de Privacidade dispõe sobre o tratamento de informações pessoais fornecidas por usuários ou terceiros ao navegar, acessar e/ou utilizar nosso website. A Plataforma www.souone.com.br ("Plataforma") é de propriedade da “Crédito One”, que compreende a empresa Aqui Negócios Correspondente Bancário Ltda. (isoladamente “Crédito One”), inscrita no CNPJ nº 30.442.854/0001-99, com sede na Av. Embaixador Abelardo Bueno 1.111, bloco 01, sala 453, Barra Olímpica, Rio de Janeiro, RJ, CEP 22775-040.

A Plataforma fornece (i) intermediação de serviços de empréstimo online e encaminhamento de proposta de crédito, situação na qual atuamos como correspondente bancário da seguinte instituição financeira parceira: ZIPDIN SOLUÇÕES DIGITAIS SOCIEDADE DE CRÉDITO DIRETO S/A, com sede na Rua Guilhermina Guinle 272, sala 801, Botafogo, Rio de Janeiro/RJ, CEP 22270-060, inscrita no CNPJ/MF sob no 37.414.009/0001-59, (“Instituições Financeiras Parceiras”); e (ii) produtos e serviços próprios, como fornecer aos usuários demais produtos e serviços associados aos serviços da “Crédito One”, realizar estudos de marketing e determinação do perfil dos usuários da Plataforma, realizar promoções e atividades de publicidade e marketing, e, em alguns casos, poderemos compartilhar suas informações com terceiros, conforme detalhado abaixo (itens (i) e (ii) acima, em conjunto, denominados os “Serviços”).`}
            </p>
          </div>
          <Divider className="my-4" />
          {topics.map((item) => (
            <div key={item.id}>
              <p className="upper-bold my-4">{item.title}</p>
              <p>{item.text}</p>
            </div>
          ))}
        </Wrapper>
      </Container>
    </Section>
  )
}

// Tópicos estruturados seguindo o mesmo template dos Termos de Uso
const topics = [
  {
    id: 1,
    title: '1. Definições',
    text: `Toda vez que houver menção aos termos “Crédito One”, “nós” ou “nossos” estaremos nos referindo à AQUI NEGÓCIOS CORRESPONDENTE BANCÁRIO LTDA; bem como toda vez que houver menção aos termos “você”, “usuário”, “seu”, “sua”, estaremos nos referindo a você usuário, que utiliza ou utilizará a Plataforma.`,
  },
  {
    id: 2,
    title: '2. Compromisso da Crédito One com a privacidade do usuário',
    text: `A Crédito One está empenhada em proteger a sua privacidade. Esta Política de Privacidade explica como a Crédito One realiza a coleta e o tratamento de informações coletados a respeito do usuário (“Dados Pessoais”).

Você fica ciente, desde já, que a análise de risco de crédito será realizada pela Crédito One, tendo como base dados obtidos de bureaus de crédito e outras agências que detenham capacidade técnica para a avaliação do risco de crédito ou de agregação de suas informações e dados, e que a nota de crédito (credit scoring) atribuída a você por referidas agências levará em consideração diversos dados previamente mantidos na base de dados e escolhidos a exclusivo critério dessas agências. A Crédito One não tem qualquer responsabilidade ou ingerência sobre os critérios adotados pelas agências para fins de atribuição de credit scoring.`,
  },
  {
    id: 3,
    title: '3. Informações coletadas pela Crédito One',
    text: `Nós coletamos Dados Pessoais para oferecer e administrar nossos serviços e produtos ofertados por meio da Plataforma. Podemos obter os seus dados Dados Pessoais: (i) diretamente de você, durante o seu cadastro ou comunicações com a Crédito One, quando você participar de pesquisas ou interagir conosco; (ii) de terceiros, quando você acessa a Plataforma através de um site de terceiro; ou (iii) através de consultas realizadas em bases de dados públicas, nos limites da legislação aplicável. As informações coletadas dependerão do tipo de acesso que você fará na Plataforma: com cadastro ou sem cadastro.

As informações coletadas dos usuários sem cadastro na Plataforma estão descritas na Política de Cookies.

Em relação aos usuários cadastrados na Plataforma, poderemos coletar as seguintes Informações:

(i) Dados de Identificação: como nome completo, CPF, RG, data de nascimento, endereço postal, endereço de e-mail, número de telefone entre outros dados de identificação do usuário.

(ii) Dados Financeiros e Dados Bancários: detalhes específicos sobre dados bancários, como nome do titular da conta, número da conta bancária, agência bancária, informações de conta poupança, declaração de renda mensal, bem como qualquer outra informação relevante.

(iii) Dados Pessoais de Mídias Sociais: ao se registrar e acessar a plataforma por meio de qualquer mídia social, como Facebook, Twitter, Google+ ou outros, se disponível essa funcionalidade, podemos coletar, armazenar e utilizar as suas informações e o conteúdo disponível em tais redes sociais.

(iv) Informações Profissionais e Financeiras: podemos solicitar suas informações profissionais e financeiras, tais como situação de emprego ou ocupação, nome do empregador ou nome da empresa, salário mensal e patrimônio líquido.

(v) Cópias de Documentos: podemos coletar cópia de documentos, tais como RG, CPF, CNH ou passaporte (quando aplicável), bem como fotografias.

Em alguns casos, a Crédito One poderá coletar algumas informações para o preenchimento automático de ficha cadastral na Plataforma e para facilitar o uso da Plataforma por você.`,
  },
  {
    id: 4,
    title: '4. Uso dos Dados Pessoais',
    text: `Os seus Dados Pessoais serão utilizados no formato disposto nesta Política de Privacidade, para as seguintes finalidades:

Categoria dos Dados Pessoais

Finalidades

Dados de Identificação;
Dados Financeiros;
Dados de Mídias Sociais;
Informações Profissionais e Financeiras; e
Cópias de Documentos

Cadastro e identificação junto à Plataforma Crédito One e à instituição financeira, inclusive mediante métodos de autenticação (por exemplo, mas não se limitando, a mensagem de texto (sms) ou e-mail)

Dados de Identificação;
Dados Financeiros;
Dados de Mídias Sociais;
Informações Profissionais e Financeiras; e
Cópias de Documentos

Prestação dos Serviços de intermediação de proposta de crédito.

Dados de Identificação;
Dados Financeiros;
Informações Profissionais e Financeiras; e
Cópias de Documentos

Análise de crédito e verificação de autenticidade das informações e documentos fornecidos, inclusive mediante tratamento e verificação cruzada. Verificação antifraude, como forma de garantir maior segurança à Crédito One, a você e a toda à sociedade, na prevenção de fraudes no sistema financeiro.

Dados de Identificação;
Dados Financeiros; e
Informações Profissionais e Financeiras

(atuação como operador) Cobrança de prestações devidas por você em decorrência dos serviços contratados por meio da plataforma, incluindo mediante o envio de mensagens de cobrança por e-mail, correio, mensagens de texto e/ou telefone

Dados de Identificação;
Dados Financeiros;
Dados de Mídias Sociais;
Informações Profissionais e Financeiras; e
Cópias de Documentos

Medidas julgadas necessárias ou recomendáveis pela Crédito One para a constante melhoria das funcionalidades da Plataforma Crédito One, incluindo melhorias de processos internos e correção de problemas na utilização da Plataforma, além de ações realizadas para a oferta dos serviços por meio da Plataforma, bem como para fornecer suporte à você e melhor entender as suas necessidades, o que pode incluir contatar você com o objetivo de realizar pesquisas de mercado e satisfação, e a utilização das informações fornecidas para customização da Plataforma de acordo com os interesses de cada usuário.

Avaliar, manter e aprimorar a segurança de nossos sites e aplicativos, inclusive para identificar e prevenir eventuais ameaças de segurança da informação e desenvolver e usar ferramentas antifraude.

Dados de Identificação;
Dados Financeiros;
Informações Profissionais e Financeiras; e
Cópias de Documentos

Notificação a respeito de alterações na Plataforma e/ou nos serviços, bem como o cumprimento das obrigações advindas da lei e assumidas no âmbito da contratação dos serviços e/ou do acesso e utilização da Plataforma

Dados de Identificação;
Dados Financeiros;
Dados de Mídias Sociais;
Informações Profissionais e Financeiras; e
Cópias de Documentos

Reporte de operações, armazenamento de informações, dados, comunicações e outros relacionados ao acesso e utilização da Plataforma e contratação dos serviços, bem como o cumprimento de outras obrigações legais e regulatórias impostas à Plataforma Crédito One em operações próprias e/ou na qualidade de correspondente bancário

Dados de Identificação;
Dados Financeiros;
Dados de Mídias Sociais; e
Informações Profissionais e Financeiras

Análise e estudo do perfil dos usuários da Plataforma, para fins de análise de dados e estatísticas e para que a Crédito One possa empenhar esforços no desenvolvimento de melhores produtos, ofertas e serviços para esse determinado perfil

Dados de Identificação;
Dados de Mídias Sociais; e
Cópias de Documentos

Oferta ou o envio de informações atinentes a produtos ou serviços que possam ser de seu interesse, por quaisquer meios disponíveis, incluindo meios eletrônicos, correio ou telefone (SMS e outros), exceto se você expressamente informar que não deseja ser contatado; bem como para análise de perfil do segmento de usuários da Crédito One para que os prestadores de serviço possam identificar demais consumidores com mesmo perfil; para cumprir com obrigações contratuais firmadas com terceiros parceiros; para nos comunicarmos com você, por quaisquer meios disponíveis, incluindo meios eletrônicos, correio ou telefone (SMS e outros); e para esclarecimento de dúvidas e/ou reclamações e gestão de canais de comunicação.`,
  },
  {
    id: 5,
    title: '5. Compartilhamento de Informações',
    text: `Podemos eventualmente compartilhar os seus Dados Pessoais com Instituições Financeiras Parceiras, bem como com os terceiros identificados abaixo para nos apoiar na execução das finalidades indicadas:

(i) Funcionários e empresas do grupo para:
• Prestação dos Serviços;
• Análise e manutenção da Plataforma;
• Atendimento às solicitações dos usuários

(ii) Parceiros comerciais, agentes e/ou prestadores de serviços, no Brasil ou no exterior, da Crédito One e/ou das Instituições Financeiras Parceiras, para:
• Prestação conjunta de Serviços;
• Cumprimento de obrigações legais e regulatórias;
• Autenticação;
• Verificação da veracidade das informações e documentos fornecidos por você;
• Decisão a respeito de pedido para contratação de quaisquer Serviços;
• Enriquecimento de suas informações;
• Envio de campanhas publicitárias e ofertas de Serviços;
• Realização de marketing online;
• Suporte e manutenção da Plataforma.

(iii) Investidores e potenciais compradores nos casos de operações societárias, para:
• Realização de auditorias;
• Permitir a conclusão de investimentos;
• Permitir a conclusão de operações societárias.

(iv) Autoridades governamentais e/ou cortes judiciais que possam nos obrigar a divulgar, por lei ou ordem judicial, a totalidade ou qualquer parte das informações, para:
• Cumprimento de exercício regular do direito e ordens judiciais;
• Atendimento à ordem judicial em face da Crédito One ou de qualquer empresa do grupo econômico.

(v) Outros provedores de crédito e instituições financeiras, para:
• Prestação de Serviços;
• Verificação da veracidade das informações e documentos fornecidos;
• Análise de crédito;
• Análise de risco e prevenção à fraude;
• Enriquecimento de informações;
• Decisão a respeito de pedido para contratação de Serviços

(vi) Operadores de sistemas de pagamento, para:
• Prestação de Serviços

(vii) Companhias e pessoas (“Agentes”) para realizar tarefas em nosso nome, para que possamos permitir aos usuários o acesso e utilização da Plataforma Crédito One e/ou a contratação dos Serviços. A menos que diferentemente contrário seja expressamente informado por nós, os Agentes não têm qualquer direito de utilizar os Dados Pessoais que compartilhamos com eles além do necessário para nos auxiliar em suas tarefas, e/ou para a devida, efetiva e eficiente operação da Plataforma e suas funcionalidades, bem como para a oferta dos serviços próprios e/ou das Instituições Financeiras Parceiras;

(viii) Agências de crédito, bureaus de crédito, bureaus de dados e outras agências (incluindo, mas sem se limitar, Boa Vista e Serasa), e/ou no Sistema de Informações de Crédito do Banco Central do Brasil (SCR), para:
• Autenticação;
• Verificação da veracidade das informações e documentos fornecidos;
• Prestação dos Serviços;
• Decisão a respeito de pedido para contratação de Serviços

(ix) Seguradoras, corretoras de seguros, correspondentes de seguros, resseguradoras, e quaisquer outros fornecedores de seguros utilizados por nós ou quaisquer das Instituições Financeiras Parceiras em relação às nossas políticas de seguro, para:
• Prestação dos Serviços;
• Análise de risco e prevenção à fraude;
• Decisão a respeito de pedidos para contratação de Serviços.

(x) Quaisquer outros terceiros com quem nós sejamos obrigados a compartilhar as informações devido a obrigações legais, contratuais e regulatórias e/ou para quem a divulgação das informações seja necessária ou recomendável para a devida, efetiva e eficiente operação da Plataforma e suas funcionalidades, bem como para a oferta dos serviços próprios e/ou das Instituições Financeiras Parceiras; e/ou para contratar e manter com terceiros serviços de armazenamento e gestão de base de dados.`,
  },
  {
    id: 6,
    title: '6. Armazenamento e guarda das Informações dos usuários',
    text: `Os seus Dados Pessoais poderão ser transferidos e armazenados em um destino fora do Brasil, na medida permitida por lei. Se os seus Dados Pessoais forem transferidos para outro país, nós adotaremos as medidas exigidas por lei para assegurar que eles continuem protegidos.

Se você tiver qualquer preocupação ou suspeita de que os seus Dados Pessoais estão em risco, por exemplo, se alguém teve acesso à sua senha, por favor entre em contato conosco imediatamente.`,
  },
  {
    id: 7,
    title: '7. Quando excluímos os Dados',
    text: `Nós estruturamos a Plataforma e as nossas operações para que os seus Dados Pessoais não sejam mantidos de maneira identificada por mais tempo do que o necessário. Ou seja, nós mantemos os Dados Pessoais somente durante o período em que eles são necessários para as finalidades descritas acima, se formos obrigados por lei ou para exercício regular de nossos direitos.`,
  },
  {
    id: 8,
    title: '8. Quais são os seus direitos com relação aos seus Dados Pessoais',
    text: `Nos termos da Lei Geral de Proteção de Dados (Lei 13.709/2018) (“LGPD”), você tem direito a:

(i) confirmação de que realizamos o tratamento dos seus Dados Pessoais;
(ii) acesso aos seus Dados Pessoais;
(iii) correção de Dados Pessoais que estejam incompletos, inexatos ou desatualizados;
(iv) anonimização, bloqueio ou eliminação de Dados Pessoais desnecessários, excessivos ou tratados em desconformidade com o disposto na LGPD;
(v) portabilidade dos seus Dados Pessoais a outro fornecedor de serviço ou produto, observados os nossos segredos comerciais e industriais, após a regulamentação pela Autoridade Nacional de Proteção de Dados;
(vi) eliminação dos Dados Pessoais tratados com base no seu consentimento, exceto nas hipóteses de conservação de Dados Pessoais previstas na LGPD;
(vii) informação sobre com quem compartilhamos os seus Dados Pessoais;
(viii) informação sobre a possibilidade de não fornecer o seu consentimento e as consequências;
(ix) revogação do seu consentimento para o tratamento dos seus Dados Pessoais, quando os Dados Pessoais forem tratados com base no seu consentimento;
(x) oposição a tratamento que viole a LGPD; e
(xi) revisão de decisões tomadas unicamente com base em tratamentos automatizados.

Você poderá enviar a sua solicitação através do e-mail meajuda@souone.com.br.`,
  },
  {
    id: 9,
    title:
      '9. Você precisa fornecer o seu consentimento para a Crédito One usar os Dados Pessoais conforme descrito nesta política?',
    text: `A LGPD estabelece diversas situações em que é permitido o tratamento de dados pessoais independentemente do consentimento do titular daqueles dados. São as chamadas “bases legais para o tratamento de dados”.

Isso significa que, se você optar por utilizar a Plataforma, em alguns casos poderemos coletar e tratar os seus dados independentemente do seu consentimento (se houver uma “base legal” prevista na LGPD que nos permita fazer isso), como: para cumprir com obrigações legais ou regulatórias, para a execução do contrato firmado com você, para proteção ao crédito, prevenção à fraude ou para atender ao seu interesse legítimo ou interesse legítimo da Crédito One.`,
  },
  {
    id: 10,
    title: '10. Alterações à Política de Privacidade',
    text: `Nós poderemos alterar as disposições desta Política a nosso critério e a qualquer tempo.

Toda vez que alterarmos materialmente esta Política, essas alterações serão válidas, eficazes e vinculantes após: (1) serem divulgadas em nossa Plataforma; ou (2) serem enviadas a você por e-mail; ou (3) serem a você comunicadas de outra forma. Caso você não queira continuar usando os Serviços após a alteração, deverá requerer o cancelamento de sua conta e/ou término de sua relação jurídica.

Você deverá verificar a versão atualizada desta Política toda vez que visitar a nossa Plataforma.`,
  },
  {
    id: 11,
    title: '11. Contato',
    text: `meajuda@souone.com.br         Tel/ WhatsApp: 021 3849-7650`,
  },
]
